import React, { useContext } from "react";
import { EnquiryContext } from "venuescanner-js/react/components/Inbox/context/EnquiryContext";
import { enquiryType } from "venuescanner-js/constants/thread";

export const LeadAwaitingLeads = () => {
  const { setEnquiryViewType } = useContext(EnquiryContext);

  return (
    <div className="lead-awaiting-leads">
      <span className="h2">&#128269;</span>
      <h3>
        We'll let you know when
        <br />
        you have more MatchLeads
      </h3>
      <p className="lead-awaiting-leads__copy">
        In the meantime, you can manage your enquiries, including any from
        MatchLeads that organisers are interested in progressing with you.
      </p>
      <button
        className="button button--light"
        onClick={() => setEnquiryViewType(enquiryType.THREAD)}
      >
        Go to Enquiries
      </button>
    </div>
  );
};

export default LeadAwaitingLeads;
